module.exports = __webpack_public_path__ + "img/vip-minecraft.a24a8d5d.png";